import { render, staticRenderFns } from "./alert-settings.vue?vue&type=template&id=28c6a440&scoped=true"
import script from "./alert-settings.vue?vue&type=script&lang=js"
export * from "./alert-settings.vue?vue&type=script&lang=js"
import style0 from "./alert-settings.vue?vue&type=style&index=0&id=28c6a440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6a440",
  null
  
)

export default component.exports